import React from "react";
import "../../styles/trainers/trainer-rating.css";
import { PeopleIcon ,RatingIcon,GymIcon,CalendarIcon, PersonArmsUpIcon,} from "../../images/icons/icons";

// Helper functions to get icon, color type, and title for each stat
export const getTrainerRatingCardIcon = (key) => {
  switch (key) {
    case "total_member":
      return <PeopleIcon />;
    case "total_rating":
      return <RatingIcon />;
    case "total_gym":
      return <GymIcon />;
    case "total_trainer":
      return < PeopleIcon/>;
    case "three_day_trial":
      return <CalendarIcon />;
    case "regular_ratings":
      return <RatingIcon />;
    case "pt_trial":
      return <PersonArmsUpIcon />;
    default:
      return <PeopleIcon />;
  }
};

export const getTrainerRatingCardIconType = (key) => {
  switch (key) {
    case "total_member":
      return "blue";
    case "total_rating":
      return "orange";
    case "total_gym":
      return "green";
    case "total_trainer":
      return "purple";
    case "three_day_trial":
      return "red";
    case "regular_ratings":
      return "indigo";
    case "pt_trial":
      return "teal";
    default:
      return "blue";
  }
};

export const getTrainerRatingCardTitle = (key) => {
  switch (key) {
    case "total_member":
      return "Total Member";
    case "total_rating":
      return "Total Rating";
    case "total_gym":
      return "Total Gym";
    case "total_trainer":
      return "Total Trainer";
    case "three_day_trial":
      return "Three Day Trial";
    case "regular_ratings":
      return "Regular Ratings";
    case "pt_trial":
      return "PT Trial";
    default:
      return key.replace(/_/g, " ").replace(/\b\w/g, (l) => l.toUpperCase());
  }
};

// Maps a clickable stat card to the table's rating_type filter value.
// Aggregate cards (total_*) clear the filter (show all).
const CARD_KEY_TO_RATING_TYPE = {
  three_day_trial: "threeday",
  pt_trial: "pt",
  regular_ratings: "regular",
};

const TrainersRatingStats = ({ statsData, onCardClick, activeRatingType }) => {
  // Dummy data for now - replace with actual API data later
  const dummyStatsData = {
    total_member: 1250,
    total_rating: 4850,
    total_gym: 45,
    total_trainer: 180,
    three_day_trial: 320,
    regular_ratings: 2800,
    pt_trial: 150,
  };

  const dataToShow = statsData || dummyStatsData;

  return (
    <div className="trainer-rating mr-kpi-grid grid-4">
      {Object.entries(dataToShow)?.map(([key, data]) => {
        const isClickable = !!onCardClick;
        const ratingType = CARD_KEY_TO_RATING_TYPE[key] || "";
        const isActive = ratingType && ratingType === activeRatingType;
        return (
          <div
            className="mr-kpi-card"
            key={key}
            onClick={() => onCardClick && onCardClick(key)}
            style={{
              cursor: isClickable ? "pointer" : "default",
              outline: isActive ? "2px solid #d90000" : "none",
            }}
          >
            <div className="mr-kpi-head">
              <div>
                <p className="mr-kpi-title">{getTrainerRatingCardTitle(key)}</p>
                <div className="mr-kpi-value-row">
                  <div className="mr-kpi-value">{data || 0}</div>
                </div>
              </div>
              <span
                className={`mr-kpi-card-icon-container ${getTrainerRatingCardIconType(key)}`}
              >
                {getTrainerRatingCardIcon(key)}
              </span>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default TrainersRatingStats;
